import React, { useState, useEffect } from 'react';
import bgimage from '../../../assests/unnamed (1).jpg'

export default function CareerForm({ selectedRole }) {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    role: '',
    otherRole: '',
    file: null,
    summary: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    if (type === 'file') {
      setFormData({ ...formData, file: e.target.files[0] || null });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  useEffect(() => {
    if (selectedRole) {
      setFormData((prev) => ({
        ...prev,
        role: selectedRole === "Other" ? "" : selectedRole,
      }));
    }
  }, [selectedRole]);

  const validate = () => {
    const newErrors = {};

    if (!formData.name || formData.name.length < 2) {
      newErrors.name = 'Name is required and should be at least 2 characters.';
    }

    if (!formData.phone || !/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = 'Phone must be a valid 10-digit number.';
    }

    if (!formData.email || !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is required and must be valid.';
    }

    if (!formData.role) {
      newErrors.role = 'Please select a role.';
    }

    if (formData.role === 'Other' && formData.otherRole.trim() === '') {
      newErrors.otherRole = 'Please specify your role.';
    }

    if (!formData.file) {
      newErrors.file = 'Please upload a resume file.';
    }

    if (!formData.summary || formData.summary.length < 10) {
      newErrors.summary = 'Summary must be at least 10 characters.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const submittedData = {
      name: formData.name,
      phone: formData.phone,
      email: formData.email,
      role: formData.role === 'Other' ? formData.otherRole : formData.role,
      file: formData.file.name,
      summary: formData.summary,
    };

    try {
      // Add a "type" to formData before sending
      const payload = {
        ...submittedData
      };

      const response = await fetch('https://www.tekitsolution.com/email_apis.php?action=career_page', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(payload).toString(),
      });

      const result = await response.json();
      alert('Form submitted successfully!');
      setFormData({
        name: '',
        role: '',
        phone: '',
        email: '',
        file: null,
        summary: ''
      });
      // setMessage('Message sent successfully!');
      // setErrors({});
    } catch (error) {
      console.error('Error:', error);
      alert('Something went wrong. Please try again.');
    }



    // console.log('Form submitted:', submittedData);
    // alert('Form submitted successfully!');
  };

  return (
    <section className="bg-gray-900 py-0 font-recoleta" id="contact">
      <div className="flex flex-col lg:flex-row h-[700px]">
        {/* Left Image */}
        <div
          className="lg:w-1/2 w-full bg-cover bg-center h-72 lg:h-[540px] content-center lg:block hidden"
          
        ><img src={bgimage} className='w-full h-full content-center mt-20' alt=''/></div>

        {/* Right Form */}
        <div className="lg:w-1/2 w-full flex items-center justify-center px-6 py-12">
          <div className="w-full max-w-2xl">
            <h5 className="text-white text-3xl font-bold uppercase mb-4 text-center">Career</h5>
            <form onSubmit={handleSubmit}>
              <div className="flex flex-wrap -mx-2">
                {/* Name */}
                <div className="w-full md:w-1/2 px-2 mb-4">
                  <input
                    type="text"
                    name="name"
                    placeholder="Name *"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full bg-transparent border border-gray-300 p-3 rounded-md text-white"
                  />
                  {errors.name && <p className="text-red-400 text-sm">{errors.name}</p>}
                </div>

                <div className="w-full md:w-1/2 px-2 mb-4">
                  <input
                    type="text"
                    name="phone"
                    placeholder="Phone *"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full bg-transparent border border-gray-300 p-3 rounded-md text-white"
                  />
                  {errors.phone && <p className="text-red-400 text-sm">{errors.phone}</p>}
                </div>

                {/* Email */}
                <div className="w-full md:w-1/2 px-2 mb-4">
                  <input
                    type="email"
                    name="email"
                    placeholder="E-mail *"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full bg-transparent border border-gray-300 p-3 rounded-md text-white"
                  />
                  {errors.email && <p className="text-red-400 text-sm">{errors.email}</p>}
                </div>

                {/* Role */}
                <div className="w-full md:w-1/2 px-2 mb-4">
                  <select
                    name="role"
                    value={formData.role}
                    onChange={handleChange}
                    className="w-full bg-transparent border border-gray-300 p-3 rounded-md text-white"
                  >
                    <option style={{ backgroundColor: 'black' }} value="">CURRENT OPENINGS</option>
                    <option style={{ backgroundColor: 'black' }} value="Business Analyst">Business Analyst</option>
                    <option style={{ backgroundColor: 'black' }} value="Ios Developer">IOS Developer</option>
                    <option style={{ backgroundColor: 'black' }} value="Jr. BDE">Jr. BDE</option>
                    <option style={{ backgroundColor: 'black' }} value="Project Manager">Project Manager</option>
                    <option style={{ backgroundColor: 'black' }} value="Other">Other</option>
                  </select>
                  {errors.role && <p className="text-red-400 text-sm">{errors.role}</p>}
                </div>

                {/* Other Role */}
                {formData.role === 'Other' && (
                  <div className="w-full px-2 mb-4">
                    <input
                      type="text"
                      name="otherRole"
                      placeholder="Please specify your role"
                      value={formData.otherRole}
                      onChange={handleChange}
                      className="w-full bg-transparent border border-gray-300 p-3 rounded-md text-white"
                    />
                    {errors.otherRole && <p className="text-red-400 text-sm">{errors.otherRole}</p>}
                  </div>
                )}

                {/* File Upload */}
                <div className="w-full px-2 mb-4">
                  <input
                    type="file"
                    name="file"
                    onChange={handleChange}
                    className="text-white file:bg-white file:text-black file:rounded-md file:px-4 file:py-2 file:border-0"
                  />
                  {errors.file && <p className="text-red-400 text-sm">{errors.file}</p>}
                </div>

                {/* Summary */}
                <div className="w-full px-2 mb-4">
                  <textarea
                    name="summary"
                    rows={5}
                    placeholder="Your Profile Summary *"
                    value={formData.summary}
                    onChange={handleChange}
                    className="w-full bg-transparent border border-gray-300 p-3 rounded-md text-white"
                  ></textarea>
                  {errors.summary && <p className="text-red-400 text-sm">{errors.summary}</p>}
                </div>

                {/* Submit Button */}
                <div className="w-full px-2 text-center">
                  <button
                    type="submit"
                    className="bg-blue-700 hover:bg-blue-800 text-white font-semibold py-2 px-8 rounded-full"
                  >
                    APPLY
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
